import { handleActions } from "redux-actions";
import { RECENT_ORDERS } from "constants/action-types";
import { fetchActions, IFetchStoreState, initialFetchState, updateActions } from "./base-reducers";
import { IV3Order as IOrder } from "constants/order-types";

export const recentOrders = handleActions<IFetchStoreState<IOrder[]>>(
    {
        ...fetchActions(RECENT_ORDERS.FETCH),
        ...updateActions(RECENT_ORDERS),
    } as any,
    initialFetchState,
);
